// Bakım modu yakalayıcı.
//
// Bakım modunda sunucu tenant/üye yüzeyindeki HER isteğe 503 + {maintenance:true}
// döner. Bu interceptor olmadan portal sessizce ölüyordu: her istek patlıyor,
// kullanıcı sebebini göremiyordu. Artık 503 yakalanıp global bir duruma yazılıyor;
// portal kabuğu tam ekran "Bakımdayız" panelini gösteriyor.
import { etiketMetni } from '@/app/domains/portal/core/etiket-ceviri';

import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { MaintenanceState } from './maintenance.state';

export const maintenanceInterceptor: HttpInterceptorFn = (req, next) => {
  const state = inject(MaintenanceState);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && error.status === 503) {
        const body = error.error as { maintenance?: boolean; message?: string } | null;

        // 503 her zaman bakım demek değil (yük dengeleyici de dönebilir) —
        // yalnız sunucunun açıkça işaretlediği yanıtı kabul et.
        if (body?.maintenance) {
          state.activate(body.message ?? etiketMetni('ui.sistemBakimdaKisaSure'));
        }
      }

      return throwError(() => error);
    }),
  );
};
